<template>
    <div>
        <Form v-if="users.length <= 1 && user" :user="user" @registered="registered" @removed="userRemoved"/>
        
        <template v-if="users.length > 1">
            There are multiple users
        </template>

        <b-sidebar right v-model="showSidebar">
            <div class="p-2">
                <Form v-if="users.length <= 1 && user" :user="user" @registered="registered" @removed="userRemoved" />
            </div>
        </b-sidebar>
    </div>
</template>

<script>
import Form from './Form'
export default {
    name: 'InvoicingForm',
    components: {
        Form
    },

    data: function () {
        return {
            users: [],
            user: null,
            providers: null,
            company: {
                vatNumber: '',
                mainId: '',
                name: '',
                address: '',
                city: '',
                bankAccount: '',
                iban: '',
                email: '',
                taxExemption: {
                    reasonCode: null,
                    reason: null
                }
            },

            taxExemptionOptions: ['PDV-RS-33', 'PDV-RS-35-7'],
            errors: {
                vat_number: null,
                main_id: null,
                email: null
            },

            validator: this.$validator(),
            showSidebar: false
        }
    },

    methods: {
        companySelected(company) {
            if (!company) return

            this.company.mainId = company.mb
            this.company.name = company.name
            this.company.address = company.address
            this.company.city = company.municipality

            let bank = company.banks.find(b => {
                return b.status
            })

            this.company.bankAccount = bank.number
        },

        userRemoved(userId) {
            this.users = this.users.filter(u => u.id != userId)
            this.user = Object.assign({})
        },

        registered(user) {
            this.user = user
            this.$emit('success')
        }
    },

    computed: {},

    mounted() {
        this.$integrationApi.get(`/karadjordje/invoices/user?project_uuid=${this.$store.getters.getCurrentProject.uuid}`).then(({data}) => {
            this.users = data

            if (this.users.length == 1) this.user = this.users[0]
            if (this.users.length < 1) this.user = {}
        }).catch(err => {
            
        })
    }
}
</script>